'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _user = require('redux/modules/user');

var userActions = _interopRequireWildcard(_user);

var _superagent = require('superagent');

var _superagent2 = _interopRequireDefault(_superagent);

var _components = require('components');

var _reactRouter = require('react-router');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ActiveAccount = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user
  };
}, (0, _extends3.default)({}, authActions, userActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ActiveAccount, _Component);

  function ActiveAccount() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ActiveAccount);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ActiveAccount.__proto__ || (0, _getPrototypeOf2.default)(ActiveAccount)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      token: _this.props.params.token,
      loading: true
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ActiveAccount, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      if (!this.props.params.token) {
        _reactRouter.browserHistory.push('/');
      } else {
        _superagent2.default.get(_config2.default.apiRoot + '/user/active-account?token=' + this.props.params.token).end(function (err, res) {
          _this2.setState({
            loading: false,
            text: res.body.success ? 'Chúc mừng bạn đã kích hoạt tài khoản thành công.' : 'Kích hoạt tài khoản thất bại'
          });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./ActiveAccount.scss');
      var _state = this.state,
          loading = _state.loading,
          text = _state.text;

      return _react2.default.createElement(
        'div',
        { className: styles.registerPage + ' container' },
        _react2.default.createElement(_reactHelmet2.default, { title: 'K\xEDch ho\u1EA1t t\xE0i kho\u1EA3n' }),
        loading && _react2.default.createElement(_components.Loading, null),
        _react2.default.createElement(
          'div',
          { className: styles.loginContent },
          _react2.default.createElement(
            'div',
            { className: styles.leftContent },
            _react2.default.createElement(
              'div',
              { className: styles.headerLogin },
              'K\xEDch ho\u1EA1t t\xE0i kho\u1EA3n'
            ),
            _react2.default.createElement(
              'div',
              { className: styles.text },
              text
            )
          ),
          _react2.default.createElement('div', { className: styles.rightContent })
        )
      );
    }
  }]);
  return ActiveAccount;
}(_react.Component), _class2.propTypes = {
  user: _react.PropTypes.object,
  params: _react.PropTypes.object
}, _temp2)) || _class);
exports.default = ActiveAccount;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Register/ActiveAccount.js
// module id = 1690
// module chunks = 0